import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function ToolSearchIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100px" height="100px" viewBox="0 0 100 100" fill="currentcolor" enableBackground="new 0 0 100 100" xmlSpace="preserve">
<path d="M87.649,81.406L59.852,53.61c3.204-4.358,5.102-9.732,5.102-15.543c0-14.503-11.799-26.302-26.302-26.302
	c-14.502,0-26.301,11.799-26.301,26.302c0,14.502,11.799,26.301,26.301,26.301c5.811,0,11.185-1.898,15.543-5.101l27.796,27.795
	L87.649,81.406z M38.653,56.368c-10.091,0-18.301-8.21-18.301-18.301c0-10.092,8.21-18.302,18.301-18.302
	c10.092,0,18.302,8.21,18.302,18.302C56.954,48.158,48.744,56.368,38.653,56.368z"/>
</svg>

  </SvgIcon>
}

export default ToolSearchIcon;
